import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Experience, Qualification } from '../models/personnel';
import { Observable } from 'rxjs';
import { Message } from '../models/domain';

@Injectable({
  providedIn: 'root'
})
export class PersonalService {

  constructor(private httpClient: HttpClient) { }

  //APIs for employee qualification

  public createQualification(qualification: Qualification): Observable<Message> {
      return this.httpClient.post<Message>('/api/personnel/qualification', qualification);
    }

    public getQualifications(employeeId: number, verificationStatus?: string, disabled?: boolean): Observable<Qualification[]> {
      return this.httpClient.get<Qualification[]>('/api/personnel/qualifications', { params: { employeeId,...(verificationStatus && { verificationStatus }) , ...(disabled && { disabled }) } });

    }

    public getQualification(id: number): Observable<Qualification> {
      return this.httpClient.get<Qualification>(`/api/personnel/qualification/${id}`);
    }

    public updateQualification(id: number, qualification: Qualification): Observable<Message> {
      return this.httpClient.put<Message>(`/api/personnel/qualification/${id}`, qualification);
    }

    public deleteQualification(id: number): Observable<Message> {
      return this.httpClient.delete<Message>(`/api/personnel/qualification/${id}`);
    }

    public uploadQualificationFile(qualificationId : number, file?: FormData): Observable<Message> {
      return this.httpClient.post<Message>(`/api/personnel/qualification/upload?qualificationId=${qualificationId }`, file);
    }

     //Experience
  public getExperiences(employeeId: number): Observable<Experience[]> {
    if (employeeId) {
      return this.httpClient.get<Experience[]>(`/api/personnel/experiences?employeeId=${employeeId}`);
    }
    return this.httpClient.get<Experience[]>(`/api/personnel/experiences`);
  }

  public getExperience(id: number): Observable<Experience> {
    return this.httpClient.get<Experience>(`/api/personnel/experience/${id}`);
  }

  public createExperience(experience: Experience): Observable<Message> {
    return this.httpClient.post<Message>(`/api/personnel/experience`, experience);
  }

  public updateExperience(id: number, experience: Experience): Observable<Message> {
    return this.httpClient.put<Message>(`/api/personnel/experience/${id}`, experience);
  }

  public deleteExperience(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/personnel/experience/${id}`);
  }

  public toggleExperienceStatus(experience: Experience): Observable<Experience> {
    return this.httpClient.put<Experience>(`/api/personnel/experience/${experience.id}`, experience);
  }

  public getEmploymentTypes(): Observable<string[]> {
    return this.httpClient.get<string[]>('/api/personnel/experience/employment-type');
  }
  public getLocationTypes(): Observable<string[]> {
    return this.httpClient.get<string[]>('/api/personnel/experience/location-type');
  }

  public uploadExperienceFile(experienceId : number, file?: FormData): Observable<Message> {
    return this.httpClient.post<Message>(`/api/personnel/experience/upload?experienceId=${experienceId }`, file);
  }
  
}
